module.exports = __webpack_public_path__ + "img/304b657.png";